<template>
  <section class="assessmentSection">
    <ProgressBar :value="15" />
    <div class="pageContent mb-12">
      <div class="pageTitle">
        We analyzed your home for <br> environmental threats.
      </div>

      <div class="text-bold">Regular smoke detectors just don’t cut it.</div>
      <div
        class="mb-4"
      >Store bought detectors do not work 75% of the time and do not call the authorities. See how our smoke communicators compare.</div>

      <div class="text-bold">Carbon monoxide risk is present for all homes.</div>
      <div
        class="mb-4"
      >Furnaces, faulty appliances, and heating elements all pose a risk for carbon monoxide poisoning.</div>

      <div v-if="recommendedEquipment.length > 0" class="recommended-section">
        We recommend adding
        <span class="text-bold">{{ recommendedEquipment[0].quantity }}  {{ recommendedEquipment[0].equipment.name }}{{ recommendedEquipment[0].quantity > 1 && 's' }}</span> for your protection
      </div>
    </div>

    <div class="equipment-section">
      <div class="pageContent">
        <div class="pageTitle productSectionTitle">
          Upgrade my system with
          <br /><span class="text-blue">Environmental Protection</span>
        </div>
        
        <EquipmentInfoWithQuantity :equipment="equipment" />
        
      </div>
    </div>

    <div class="continue-section">
      <continue-button :to="continueTo" />
      <ModuleNeedHelp />
    </div>
  </section>
</template>

<script>
import axios from 'axios'
import ProgressBar from "../components/ProgressBar.vue";
import EquipmentInfoWithQuantity from '../components/EquipmentInfoWithQuantity.vue';
import ModuleNeedHelp from "../components/ModuleNeedHelp.vue";
import EquipmentService from "../Services/Equipment";

let Equipment = new EquipmentService();

export default {
  components: {
    ProgressBar,
    EquipmentInfoWithQuantity,
    ModuleNeedHelp,
  },
  data: () => ({
    descriptionVisibilities: [false, false],
    equipment: [],
    recommendedEquipment: [],
    continueTo: `/system`
  }),
  async created() {
    let equipment = await Equipment.getByCategory('environmental')
    this.equipment = equipment;

    let res = await axios.get('/ajax/advice')
    this.recommendedEquipment = res.data

  }
};
</script>

<style scoped>
.recommended-section {
  padding: 1rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  margin-top: 2rem;
}
</style>
<style src="./AssessmentModule.css" scoped></style>
<style src="../../sass/components/continue-section.css" scoped></style>
